import React from "react";
import lateralHiring from "../../../assets/images/business1.jpg";
import dedicatedSupport from "../../../assets/images/business2.jpg";
import jobReady from "../../../assets/images/business3.jpg";
import diverseTalent from "../../../assets/images/business4.jpg";

function WhySimpliRecruit() {
    const features = [
        {
            img: lateralHiring,
            title: "Lateral hiring at Zero Cost",
            desc: "Build your ideal tech team with skilled professionals at no cost.",
        },
        {
            img: dedicatedSupport,
            title: "Dedicated Support",
            desc: "Get expert assistance at every step to streamline your hiring process.",
        },
        {
            img: jobReady,
            title: "Job Ready Candidates",
            desc: "Access a pool of pre-vetted, job-ready candidates and hire the right fit, fast.",
        },
        {
            img: diverseTalent,
            title: "Diverse Talent Pool",
            desc: "Discover top tech talent from a diverse, skilled network.",
        },
    ];

    return (
        <div className="bg-[#E4EEFC] py-16 px-6 md:px-20">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10">
                Why Hire from SmikRecruit?
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {features.map((feature, index) => (
                    <div
                        key={index}
                        className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition duration-300 text-center"
                    >
                        <img src={feature.img} alt={feature.title} className="mx-auto w-full mb-4" loading="lazy"/>
                        <h3 className="text-lg font-semibold text-gray-900">{feature.title}</h3>
                        <p className="text-gray-600 text-md mt-2">{feature.desc}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default WhySimpliRecruit;
